import Vue from 'vue'
import Router from 'vue-router'

import store from './store'

import Registration from './views/Registration.vue'
import Login from './views/Login.vue'
import ResetPassword from './views/ResetPassword.vue'
import Orders from './views/Orders.vue'
import Order from './views/Order.vue'
import Profile from './views/Profile.vue'

Vue.use(Router)

function requiresAuth(to, from, next) {
  if (!store.getters.isAuthenticated) {
      next({
        path: '/login/',
        // query: {
        //   redirect: to.fullPath,
        // },
      });
  } else {
    next();
  }
}

function authenticated(to, from, next) {
  if(store.getters.isAuthenticated) {
    next({
      path: '/',
    });
  } else {
    next();
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/registration/',
      name: 'registration',
      component: Registration,
      beforeEnter: authenticated,
    },
    {
      path: '/reset-password/',
      name: 'reset-password',
      component: ResetPassword,
      beforeEnter: authenticated,
    },
    {
      path: '/login/',
      name: 'login',
      component: Login,
      beforeEnter: authenticated,
    },
    {
      path: '/',
      name: 'home',
      component: Orders,
      beforeEnter: requiresAuth
    },
    {
      path: '/order/:id',
      name: 'order',
      component: Order,
      beforeEnter: requiresAuth
    },
    {
      path: '/profile/:id',
      name: 'profile',
      component: Profile,
      beforeEnter: requiresAuth
    },
  ]
});

export default router;